import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import { Typography } from "@material-ui/core";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import { default as MuiCheckbox } from "@material-ui/core/Checkbox";
//import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
//import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";

export const SquareCheckbox = (props) => {
	const { name, label, value, checked, handleChange } = props;
	const ColorCheckbox = withStyles({
		root: {
			color: "#707070",
			"&$checked": {
				color: "#707070",
			},
		},
		checked: {},
	})((props) => <MuiCheckbox color="default" {...props} />);

	return (
		<FormControlLabel
			control={
				<ColorCheckbox
					id={`${name}_${value}_checkbox`}
					style={{ paddingTop: 3, paddingBottom: 0 }}
					checked={checked}
					onChange={(event) => {
						if (handleChange) {
							handleChange({ key: event.target.name, value: value });
						}
					}}
					icon={<CheckBoxOutlinedIcon />}
					checkedIcon={<CheckBoxOutlineBlankOutlinedIcon />}
					name={name}
				/>
			}
			label={<Typography style={{ fontSize: 13 }}>{label}</Typography>}
		/>
	);
};

SquareCheckbox.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.string,
	checked: PropTypes.bool,
	handleChange: PropTypes.func,
};
